import { useRef } from "react";
import styles from "./style.module.scss";
import "./style.scss";

import { Image } from "antd";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Autoplay, EffectCoverflow, EffectCreative, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useApiData } from "../../context/ApiDataContext";

const Transaction = () => {
  const refTop = useRef();
  const refBottom = useRef();

  const { data } = useApiData();

  const swiperEnum = [
    {
      data: data?.fundList.slice(0, Math.floor(data?.fundList.length / 2)),
      ref: refTop,
      dir: "",
      slideContent: (itemData) => (
        <>
          <Image src={itemData?.img} alt="img" preview={false} className={styles.img} />
          <div className={styles.content}>{itemData?.content}</div>
          <div>{itemData?.username}</div>
        </>
      ),
    },
    {
      data: data?.fundList.slice(Math.floor(data?.fundList.length / 2)).reverse(),
      ref: refBottom,
      dir: "rtl",
      slideContent: (itemData) => (
        <>
          <div>{itemData?.username}</div>
          <div className={styles.content}>{itemData?.content}</div>
          <Image src={itemData?.img} alt="img" preview={false} className={styles.img} />
        </>
      ),
    },
  ];

  const items = (props) => {
    return props.data.map((_item, index) => (
      <SwiperSlide key={index}>
        <div className={styles.swiperSlide}>{props.slideContent(_item)}</div>
      </SwiperSlide>
    ));
  };

  return (
    <div className={`${styles.swiperArea} transaction-swiper-area`}>
      {swiperEnum.map((item, index) => {
        return (
          <div key={index} className={styles.swiperContainer}>
            {data && data.fundList?.length > 0 && (
              <Swiper
                ref={item.ref}
                navigation={false}
                modules={[EffectCoverflow, EffectCreative, Autoplay, Pagination]}
                className="custom-swiper"
                spaceBetween={10}
                slidesPerView={"auto"}
                speed={10000}
                dir={item.dir}
                autoplay={{
                  delay: 1000,
                  disableOnInteraction: false,
                }}
                pagination={false}
                loop={true}
                // initialSlide={5}
                direction={"horizontal"}
              >
                {items(item)}
              </Swiper>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Transaction;
